"use client";

import { ArrowRight, TrendingUp, Cpu, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Synergy() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "No 01",
    title: "OTA REVENUE MANAGEMENT",
    Icon: TrendingUp,
    body: "We optimize your presence on major booking platforms to ensure maximum visibility and conversion. Our data-driven approach turns your OTA listings into high-performing revenue channels.",
    italic: "Strategic positioning for maximum yield.",
    offset: "md:translate-y-0"
  }, {
    number: "No 02",
    title: "HOSPITALITY TECH STACK",
    Icon: Cpu,
    body: "We audit and implement cutting-edge hospitality technology, from PMS integrations to automated pricing tools, ensuring your property operates with peak efficiency and modern intelligence.",
    italic: "Technology that drives profitability.",
    offset: "md:-translate-y-12"
  }, {
    number: "No 03",
    title: "REVENUE AUDITS",
    Icon: FileText,
    body: "Comprehensive revenue audits that identify hidden opportunities and plug profit leaks. We provide actionable insights to refine your pricing strategy and boost your bottom line.",
    italic: "Clarity in every revenue stream.",
    offset: "md:translate-y-12"
  }];
  return <section data-section-id="3504" id="marketingrevenuesynergy" className="bg-slate-50 text-slate-900 py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={header.ref} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default font-bold tracking-[0.3em] uppercase mb-6 text-blue-600" style={{
          fontSize: "11px"
        }}>
            Our Expertise
          </p>
          <h2 className="font-default font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight text-slate-950 leading-[0.95] mb-6">
            CORE PILLARS
            <span className="text-blue-600">.</span>
          </h2>
          <p className="font-default italic text-lg text-slate-600 max-w-xl mx-auto">
            Driving sustainable growth through precision revenue management.
          </p>
        </div>

        {}
        <div ref={cardsReveal.ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div key={i} data-index={i} className={`group transition-all duration-1000 ease-out ${pillar.offset} ${cardsReveal.isVisible ? "opacity-100" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="relative h-full min-h-[520px] p-10 flex flex-col rounded-lg border border-slate-200 bg-white transition-all duration-500 ease-out group-hover:-translate-y-2 shadow-lg">
                  {}
                  <div className="absolute inset-0 rounded-lg border-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none border-blue-600" />

                  {}
                  <div className="flex items-center justify-between mb-10">
                    <span className="font-default font-bold tracking-widest uppercase text-blue-600" style={{
                  fontSize: "13px"
                }}>
                      {pillar.number}
                    </span>
                  </div>

                  {}
                  <div className="mb-10">
                    <Icon className="w-16 h-16 transition-transform duration-500 group-hover:scale-110 text-blue-600" strokeWidth={1.5} />
                  </div>

                  {}
                  <h3 className="font-default font-extrabold text-3xl md:text-4xl text-slate-950 mb-5 tracking-tight leading-tight">
                    {pillar.title}
                  </h3>

                  {}
                  <div className="h-[2px] w-6 mb-6 bg-blue-600" />

                  {}
                  <p className="font-default font-light text-[17px] leading-relaxed text-slate-800 mb-2">
                    {pillar.body}
                  </p>
                  <p className="font-default italic text-[17px] leading-relaxed text-slate-600 mb-10">
                    {pillar.italic}
                  </p>

                  {}
                  <div className="mt-auto pt-6">
                    <Button asChild variant="ghost" className="h-auto p-0 font-default font-bold tracking-widest uppercase text-xs hover:bg-transparent group/btn text-blue-600">
                      <Link to="#">
                        Learn More
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}